import { Injectable } from "@angular/core";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { OpenIdUser } from "@app/shared/models";
import { isNil } from "@app/utils";
import { AddUserModel } from "./models/add-user.model";

@Injectable()
export class ManageUsersService {
	constructor() {}

	setFullName(field: FormlyFieldConfig): void {
		const firstName = field.model['FirstName'] ?? '';
		const lastName = field.model['LastName'] ?? '';
		const fullName = `${firstName} ${lastName}`.trim();
		field.model['FullName'] = fullName;

		const patchValues: any = {
			FullName: fullName,
		};
		field.form.patchValue(patchValues, { emitEvent: false });
	}

	setOpenIdUser(field: FormlyFieldConfig, user?: OpenIdUser): void {
		let patchValues: any = {
			OpenIdUser: isNil(user) ? null : user,
		};

		if (!isNil(user)) {
			field.model['OpenIdUser'] = user;
			field.model['Email'] = user.Email;
			field.model['UserName'] = user.Username;
			field.model['FirstName'] = user.FirstName;
			field.model['LastName'] = user.LastName;
			field.model['FullName'] = !isNil(user.FullName) && user.FullName.length > 0 ? user.FullName
				: `${user.FirstName} ${user.LastName}`.trim();

			patchValues = {
				...patchValues,
				Email: user.Email,
				UserName: user.Username,
				FirstName: user.FirstName,
				LastName: user.LastName,
				FullName: user.FullName,
			};
		} else {
			field.model['OpenIdUser'] = null;
		}

		field.form.patchValue(patchValues, { emitEvent: true });
		field.options.checkExpressions(field.parent);
	}

	isOpenIdUser(model: Partial<AddUserModel>): boolean {
		return model.OpenIdUser && !isNil(model.OpenIdUser.Email);
	}
}
